var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.775,
    y1: 0.086,
    x2: 0.148,
    y2: 0.829,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa087"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eb6c6b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3119",
    "data-name": "Rectangle 3119",
    width: 26,
    height: 32,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13693",
    "data-name": "Group 13693",
    transform: "translate(-12 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13051",
    "data-name": "Path 13051",
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    transform: "translate(12 12)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13690",
    "data-name": "Group 13690",
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13692",
    "data-name": "Group 13692",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13691",
    "data-name": "Group 13691",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13052",
    "data-name": "Path 13052",
    d: "M18.208,19.1H7.79A8.528,8.528,0,0,0,0,27.563C0,31.792,3.122,32,7.21,32l1.371,0h8.838l1.369,0C22.877,32,26,31.793,26,27.563A8.529,8.529,0,0,0,18.208,19.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13053",
    "data-name": "Path 13053",
    d: "M14.577,14.734H15.89a1.906,1.906,0,0,1,1.176.4,8.012,8.012,0,0,0,2.088-.559,7.1,7.1,0,0,0,.477-.825V10.91a2.5,2.5,0,0,1,.661-1.7,7.418,7.418,0,0,0-14.585,0,2.5,2.5,0,0,1,.66,1.7v2.845A7.414,7.414,0,0,0,13,17.829c.045,0,.089-.006.134-.007a1.85,1.85,0,0,1-.457-1.208A1.893,1.893,0,0,1,14.577,14.734Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13054",
    "data-name": "Path 13054",
    d: "M3.724,15.811h.083a1.643,1.643,0,0,0,1.65-1.637V10.91a1.63,1.63,0,0,0-.918-1.462,8.477,8.477,0,0,1,16.92,0,1.628,1.628,0,0,0-.918,1.462v3.264a1.634,1.634,0,0,0,.118.608,8.161,8.161,0,0,1-3.939,1.3,1,1,0,0,0-.831-.448H14.576a.979.979,0,1,0,0,1.958h1.313a.985.985,0,0,0,.874-.529A8.938,8.938,0,0,0,21.3,15.55a1.64,1.64,0,0,0,.888.261h.082a1.642,1.642,0,0,0,1.65-1.637V10.909a1.628,1.628,0,0,0-.94-1.472,10,10,0,0,0-19.967,0,1.627,1.627,0,0,0-.942,1.472v3.265A1.644,1.644,0,0,0,3.724,15.811Z",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.8062e8a90bac5ec031150b26d36bd8d8.svg";
export { ForwardRef as ReactComponent };